export default __webpack_public_path__ + "static/media/bg-camp-main.60a5d095.png";